import { useRef, useState } from "react";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import logo from '../assest/logo2.png'
import character from '../assest/character1.png'

function CertificateGenerator() {

    const certRef = useRef(null);
    const [generating, setGenerating] = useState(false);

    const handleGenerate = async () => {
        if (!certRef.current) return;

        try {
            setGenerating(true);

            const canvas = await html2canvas(certRef.current, { scale: 2 });
            const imgData = canvas.toDataURL("image/png");

            // Certificate real px size
            const certW = canvas.width;
            const certH = canvas.height;

            // Convert px → mm
            const mmW = certW * 0.264583;
            const mmH = certH * 0.264583;

            // PDF EXACTLY same size as certificate
            const pdf = new jsPDF({
                orientation: mmW > mmH ? "landscape" : "portrait",
                unit: "mm",
                format: [mmW, mmH]   // <<< FIX: NO A4, EXACT SIZE
            });

            pdf.addImage(imgData, "PNG", 0, 0, mmW, mmH);

            const blob = pdf.output("blob");
            const url = URL.createObjectURL(blob);
            window.open(url, "_blank");
        } catch (err) {
            console.error(err);
        } finally {
            setGenerating(false);
        }
    };

    return (
        <div className="p-6 min-h-screen bg-gray-50 flex flex-col items-center gap-6" style={{ fontFamily: "sans-serif" }}>
            <div className="w-full max-w-3xl">
                <div className="flex justify-end mb-4">
                    <button
                        onClick={handleGenerate}
                        disabled={generating}
                        className="px-4 py-2 rounded-lg shadow-md bg-gradient-to-r from-[#6b46c1] to-[#b83280] text-white font-semibold disabled:opacity-60"
                    >
                        {generating ? "Generating..." : "Generate"}
                    </button>
                </div>
                <div ref={certRef} className="w-full h-auto flex justify-center items-center">
                    <div
                        className="w-[900px] h-[630px] bg-gradient-to-br from-[#A73884] to-[#803A85] p-6 rounded-lg flex justify-center items-center"
                    >
                        {/* White Content Box */}
                        <div className="w-full h-full bg-white rounded-lg p-7 relative overflow-hidden">
                            {/* Logo */}
                            <div className="absolute top-4 right-7">
                                <img
                                    src={logo}
                                    alt="Logo"
                                    className="w-44 object-contain"
                                />
                            </div>

                            {/* Title */}
                            <h1 className="text-5xl text-black" style={{ fontWeight: "bolder" }}>CERTIFICATE</h1>
                            <p className="tracking-[0.25em] text-sm text-gray-700 mt-3" style={{ fontWeight: "bold" }}>
                                OF COMPLETION
                            </p>

                            {/* Sub text */}
                            <p className="mt-10 text-gray-700 text-sm" style={{fontWeight: 500}}>This certifies that</p>

                            {/* Username */}
                            <div className="mt-3 text-xl font-bold border-b border-black inline-block pb-1">
                                LMS User Second
                            </div>

                            <p className="mt-3 text-gray-700 text-sm">
                                has successfully completed the
                                <span className="font-bold ml-1">English</span>
                            </p>

                            <p className="mt-5 text-gray-700 text-sm">conducted by</p>

                            {/* Date */}
                            <div className="text-sm font-semibold mt-1">November 17, 2025</div>

                            {/* CEO Name */}
                            <div className="absolute bottom-16 left-10">
                                <p className="font-bold text-lg">Umer Aziz</p>
                                <p className="text-xs text-gray-600">Chief Executive Officer</p>
                            </div>

                            {/* Character Image */}
                            <div className="absolute bottom-6 right-[-40px]">
                                <img
                                    src={character}
                                    alt="Character"
                                    className="w-80 object-contain"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default CertificateGenerator;